import React, { Component } from 'react'
import { Route, Routes ,Navigate} from 'react-router-dom';
import { Provider } from 'react-redux';
import clientStore from './store/store'
import ComponentWithRouter from './components/withRouter'
import LandingPage from './pages/landingPage';
import Register from './pages/register'

const LandingPageWithRouter = ComponentWithRouter(LandingPage);
const RegisterPageWithRouter = ComponentWithRouter(Register);

export default class App extends Component {
  render() {
    return (
      <div>
        <Provider store={clientStore}>
          <Routes>
            <Route key="LandingPage" path="LandingPage" element={<LandingPageWithRouter />} />
            <Route key="register" path="register" element={<RegisterPageWithRouter />} />
            <Route key="notFound" path="*" element={<Navigate replace to="/client/landingPage"/>} />
          </Routes>
        </Provider>
      </div>
    )
  }
}
